export default "__VITE_ASSET__wdY67vXI__"